import TableAccess from "data/util/TableAccess";
import TableStore from "data/TableStore";
import { setExclusion } from "data/MappingStore";
import BuildMappingTreeVisitor from "../../selectors/BuildMappingTreeVisitor";

export const buildMergeExclusions = (state) => {
    state = {...state};
    const tree = new BuildMappingTreeVisitor(
        state,
        new TableAccess(TableStore.getState()),
        new TableAccess(TableStore.getSnapshot()),
    )
        .execute()
        .getTree();

    const processItem = (st, fields) => {
        // By Default, the checkboxes should be Unchecked if the Post-Mapped
        // value (targetValue) is NULL, and the Pre-Mapped value (sourceValue)
        // is NOT NULL; else, they should be CHECKED. (user can then override
        // as desired)
        st = (fields || []).reduce((s, field) => {
            if (Array.isArray(field.children) && field.children.length) {
                s = processItem(s, field.children); // walk
            }
            return setExclusion(
                s,
                field.exclusionInfo.recordId,
                field.exclusionInfo.columnKey,
                field.itemKey,
                !(field.targetValue == null && field.sourceValue != null),
            );
        }, st);
        return st;
    };

    state = processItem(state, tree.children);

    return state.exclusions;
};



// WEBPACK FOOTER //
// ./app/data/util/merge/buildMergeExclusions.js